import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

// mm/yyyy
const mask = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

export default {
    mask: mask,
    guide: false,
    pipe: createAutoCorrectedDatePipe('mm/yyyy'),
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
